// Mobile Navigation Toggle
const menuToggle = document.querySelector('.menu-toggle');
const nav = document.querySelector('nav');
const navOverlay = document.querySelector('.nav-overlay');
const navLinks = document.querySelectorAll('.nav-links a');
const body = document.body;

// Create overlay element if it doesn't exist
if (!navOverlay) {
  const overlay = document.createElement('div');
  overlay.classList.add('nav-overlay');
  document.body.appendChild(overlay);
}

// Toggle mobile navigation
if (menuToggle) {
  menuToggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isActive = nav.classList.contains('nav-active');

    if (isActive) {
      // Close navigation
      nav.classList.remove('nav-active');
      menuToggle.classList.remove('active');
      document.querySelector('.nav-overlay').classList.remove('active');
      body.style.overflow = 'auto';
    } else {
      // Open navigation
      nav.classList.add('nav-active');
      menuToggle.classList.add('active');
      document.querySelector('.nav-overlay').classList.add('active');
      body.style.overflow = 'hidden';
    }
  });
}

// Close navigation when clicking on links
navLinks.forEach(link => {
  link.addEventListener('click', () => {
    if (window.innerWidth <= 768) {
      nav.classList.remove('nav-active');
      menuToggle.classList.remove('active');
      document.querySelector('.nav-overlay').classList.remove('active');
      body.style.overflow = 'auto';
    }
  });
});

// Close navigation when clicking on overlay
document.addEventListener('click', (e) => {
  if (e.target.classList.contains('nav-overlay')) {
    nav.classList.remove('nav-active');
    menuToggle.classList.remove('active');
    document.querySelector('.nav-overlay').classList.remove('active');
    body.style.overflow = 'auto';
  }
});

// Close navigation on window resize
window.addEventListener('resize', () => {
  if (window.innerWidth > 768) {
    nav.classList.remove('nav-active');
    menuToggle.classList.remove('active');
    document.querySelector('.nav-overlay').classList.remove('active');
    body.style.overflow = 'auto';
  }
});

// Close navigation with escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && nav.classList.contains('nav-active')) {
    nav.classList.remove('nav-active');
    menuToggle.classList.remove('active');
    document.querySelector('.nav-overlay').classList.remove('active');
    body.style.overflow = 'auto';
  }
});

// Set active link based on current page
const currentPath = window.location.pathname;
const fileName = currentPath.split('/').pop() || 'index.html';

navLinks.forEach(link => {
  const linkPath = link.getAttribute('href');
  if (linkPath === fileName || (fileName === '' && linkPath === 'index.html')) {
    link.classList.add('active');
  }
});


// ENHANCED DIALOG BOX WITH IMPROVED ACCESSIBILITY AND TIMING
const floatingBtn = document.querySelector(".floating-btn");
const closeBtn = document.querySelector(".dialog-close-btn-container");
const dialogBox = document.querySelector(".dialog");
const html = document.querySelector("html");

// Enhanced cookie management with 3-day expiry
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Enhanced dialog management with accessibility
function openDialog() {
  if (dialogBox) {
    dialogBox.showModal();
    dialogBox.setAttribute('aria-hidden', 'false');
    html.style.overflow = "hidden";

    // Focus management - focus first input
    const firstInput = dialogBox.querySelector('input[type="text"], input[type="email"]');
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }

    // Trap focus within dialog
    trapFocus(dialogBox);
  }
}

function closeDialog() {
  if (dialogBox) {
    // Clear form fields
    const form = dialogBox.querySelector('form');
    if (form) form.reset();

    dialogBox.close();
    dialogBox.setAttribute('aria-hidden', 'true');
    html.style.overflow = "auto";

    // Return focus to floating button
    if (floatingBtn) floatingBtn.focus();
  }
}

// Focus trap for accessibility
function trapFocus(element) {
  const focusableElements = element.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  element.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    }

    // Close on Escape key
    if (e.key === 'Escape') {
      closeDialog();
    }
  });
}

// Auto-show dialog for first-time visitors or after 3 days
window.addEventListener("load", () => {
  const lastShown = getCookie("popupLastShown");
  const now = new Date().getTime();

  if (!lastShown) {
  // First-time visitor - show after 5 seconds
    setTimeout(() => {
      openDialog();
      setCookie("popupLastShown", now.toString(), 3);
    }, 5000);
  } else {
    const lastShownTime = parseInt(lastShown);
    const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;

    if (now - lastShownTime > threeDaysInMs) {
      // More than 3 days since last shown
      setTimeout(() => {
        openDialog();
        setCookie("popupLastShown", now.toString(), 3);
      }, 8000); // Slightly longer delay for returning visitors
    }
  }
});

// Event listeners
if (floatingBtn) {
  floatingBtn.addEventListener("click", openDialog);

  // Keyboard accessibility for floating button
  floatingBtn.addEventListener("keydown", (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openDialog();
    }
  });
}

if (closeBtn) {
  closeBtn.addEventListener("click", closeDialog);

  // Keyboard accessibility for close button
  closeBtn.addEventListener("keydown", (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      closeDialog();
    }
  });
}

// Click outside to close (optional - can be removed if not desired)
if (dialogBox) {
  dialogBox.addEventListener("click", (e) => {
    if (e.target === dialogBox) {
      closeDialog();
    }
  });
}


// NAVIGATE TO HOME PAGE ON LOGO CLICK
const logo = document.querySelector(".logo-container") || document.querySelector(".header a");
if (logo) {
  logo.addEventListener("click", () => {
    window.location.href = "index.html";
  });
}

// DROP SHADOW UNDER NAVIGATION AFTER SCROLLING
window.addEventListener("scroll", () => {
  const scrolled = window.pageYOffset;
  const value = 100;
  const navbar = document.querySelector(".header");

  if (scrolled > value) {
    navbar.classList.add("nav-drop-shadow");
  } else {
    navbar.classList.remove("nav-drop-shadow");
  }
});

// SMOOTH SCROLLING FOR ANCHOR LINKS
document.addEventListener("DOMContentLoaded", () => {
  // Add smooth scrolling to all anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = link.getAttribute("href");
      const targetSection = document.querySelector(targetId);

      if (targetSection) {
        const headerHeight = document.querySelector(".header").offsetHeight;
        const targetPosition = targetSection.offsetTop - headerHeight - 20; // 20px extra padding

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});

// FLOATING IMAGE ANIMATION - Enhanced for better performance and tighter grouping
let parallaxContainer = document.querySelector(".free-floating-image-container");
const image1 = document.querySelector(".parallaxImage1");
const image2 = document.querySelector(".parallaxImage2");
const image3 = document.querySelector(".parallaxImage3");
const image4 = document.querySelector(".parallaxImage4");
const image5 = document.querySelector(".parallaxImage5");
const image6 = document.querySelector(".parallaxImage6");
const image7 = document.querySelector(".parallaxImage7");
const image8 = document.querySelector(".parallaxImage8");

if (parallaxContainer && window.getComputedStyle(parallaxContainer).display !== 'none') {
  let ticking = false;

  function updateParallax() {
    const scrolled = window.pageYOffset;
    const rate = scrolled * -0.15; // Reduced base rate for tighter movement

    // Group images with similar speeds to reduce gaps
    // Left side cluster (images 4, 5, 6)
    if (image4) image4.style.transform = `translate3d(0, ${rate * 0.8}px, 0)`;
    if (image5) image5.style.transform = `translate3d(0, ${rate * 0.9}px, 0)`;
    if (image6) image6.style.transform = `translate3d(0, ${rate * 0.7}px, 0)`;

    // Right side cluster (images 1, 2, 3, 8)
    if (image1) image1.style.transform = `translate3d(0, ${rate * 0.6}px, 0)`;
    if (image2) image2.style.transform = `translate3d(0, ${rate * 0.5}px, 0)`;
    if (image3) image3.style.transform = `translate3d(0, ${rate * 0.4}px, 0)`;
    if (image8) image8.style.transform = `translate3d(0, ${rate * 0.7}px, 0)`;

    // Bottom image (image 7) moves independently
    if (image7) image7.style.transform = `translate3d(0, ${rate * 0.3}px, 0)`;

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener("scroll", requestTick);
}

// FAQs ACCORDION - Modern Implementation
const accordionButtons = document.querySelectorAll(".accordian-btn");

accordionButtons.forEach((button, index) => {
  button.addEventListener("click", () => {
    const questionContainer = button.parentElement;
    const answerContainer = questionContainer.querySelector(".answer-container");
    const isActive = questionContainer.classList.contains("active");

    // Close all other accordions
    accordionButtons.forEach((otherButton, otherIndex) => {
      if (otherIndex !== index) {
        const otherContainer = otherButton.parentElement;
        const otherAnswer = otherContainer.querySelector(".answer-container");
        otherContainer.classList.remove("active");
        otherAnswer.classList.remove("active");
      }
    });

    // Toggle current accordion
    if (isActive) {
      questionContainer.classList.remove("active");
      answerContainer.classList.remove("active");
    } else {
      questionContainer.classList.add("active");
      answerContainer.classList.add("active");
    }
  });
});